import axios from "axios";

let BASE_URL = "https://api.inhome.com.my/api/"; // Default to development
if (process.env.NODE_ENV === "production") {
  BASE_URL = "https://api.inhome.com.my/api/";
} else if (process.env.NODE_ENV === "development") {
  BASE_URL = "http://localhost:5000/api/";
}

// Fallback for any undefined environment
if (!BASE_URL) {
    BASE_URL = "https://api.inhome.com.my/api/";
    console.warn("BASE_URL was undefined, falling back to development URL");
}

export const publicRequest = axios.create({
    baseURL: BASE_URL,
    headers: { token: "&KZqXDh/Trf.ooWOdqX}Y)g@$'2UO0}09m9v1?BzcGum#RVVPH" },
  });
  
  export const userRequest = axios.create({
    baseURL: BASE_URL,
    headers: { token: "&KZqXDh/Trf.ooWOdqX}Y)g@$'2UO0}09m9v1?BzcGum#RVVPH" },
  });
  